import React from 'react'
import Button, { TYPES } from '../../Button/index'
import { TARGET_BLANK } from '../../Link/index'
import {
  useGetAccountPreferenceCenterUrlQuery,
  type GetAccountPreferenceCenterUrlQuery,
} from './queries.generated'

function getPreferenceCenterUrlFromQuery (
  queryData: GetAccountPreferenceCenterUrlQuery | undefined,
): string | null {
  if (queryData == null) {
    return null
  }
  const current = queryData.userInfoCurrent
  if (current == null || current.userInfo == null) {
    return null
  }
  const url = current.userInfo.preferenceCenterUrl
  return url ?? null
}

export type BrazePreferenceCenterEmailSettingsProps = {
  jwt?: string
  manageEmailPreferencesCta: string
  preferenceCenterUnavailable: string
}

export function BrazePreferenceCenterEmailSettings ({
  jwt,
  manageEmailPreferencesCta,
  preferenceCenterUnavailable,
}: BrazePreferenceCenterEmailSettingsProps) {
  const { data, loading, error } = useGetAccountPreferenceCenterUrlQuery({
    skip: !jwt,
    context: { jwt },
  })

  const preferenceCenterUrl = getPreferenceCenterUrlFromQuery(data)

  if (!jwt) {
    return null
  }

  if (loading) {
    return (
      <div
        className="my-account-settings-V2__notification-settings-controls my-account-settings-V2__preference-center-braze my-account-settings-V2__preference-center-braze--loading"
        aria-busy="true"
      />
    )
  }

  if (error || !preferenceCenterUrl) {
    return (
      <div className="my-account-settings-V2__notification-settings-controls my-account-settings-V2__preference-center-braze">
        {preferenceCenterUnavailable}
      </div>
    )
  }

  return (
    <div className="my-account-settings-V2__preference-center-braze">
      <Button
        type={TYPES.SECONDARY}
        url={preferenceCenterUrl}
        target={TARGET_BLANK}
        directLink
        className="my-account-settings-V2__preference-center-cta"
      >
        {manageEmailPreferencesCta}
      </Button>
    </div>
  )
}
